<script>
import { h, defineComponent } from 'vue';
import { OhVueIcon } from "oh-vue-icons";

export const SortAscIcon = defineComponent({
    name: 'SortAscIcon',
    setup() {
        return () => h(OhVueIcon, { name: 'md-arrowupward', scale: 0.95})
    }
})

export const SortDescIcon = defineComponent({
    name: 'SortDescIcon',
    setup() {
        return () => h(OhVueIcon, { name: 'md-arrowdownward', scale: 0.95})
    }
})

export const NextIcon = defineComponent({
    name: 'NextIcon',
    setup() {
        return () => h(OhVueIcon, { name: 'md-navigatenext-round', scale: 0.95})
    }
})

export const PrevIcon = defineComponent({
    name: 'PrevIcon',
    setup() {
        return () => h(OhVueIcon, { name: 'md-navigatebefore-round', scale: 0.95})
    }
})

export const FirstIcon = defineComponent({
    name: 'FirstIcon',
    setup() {
        return () => h(OhVueIcon, { name: 'md-firstpage-round', scale: 0.95})
    }
})

export const LastIcon = defineComponent({
    name: 'LastIcon',
    setup() {
        return () => h(OhVueIcon, { name: 'md-lastpage-round', scale: 0.95})
    }
})
</script>